import { render, staticRenderFns } from "./GeneralIngoingInvoicesPage.vue?vue&type=template&id=c2a98660&scoped=true&"
import script from "./GeneralIngoingInvoicesPage.vue?vue&type=script&lang=ts&"
export * from "./GeneralIngoingInvoicesPage.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralIngoingInvoicesPage.vue?vue&type=style&index=0&id=c2a98660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a98660",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VCombobox,VDivider,VIcon,VProgressLinear,VRow,VSheet,VTooltip})
